module.exports = __webpack_public_path__ + "static/img/wx_en.6d52578.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/honggu/wx_en.png
// module id = bNz+
// module chunks = 0